import { createContext } from "react";
import { GfeAction } from "./gfe_actions";
import { GfeState } from "./reducer/gfe_reducer";

export type GfeContextType = {
  state: GfeState;
  dispatch: React.Dispatch<GfeAction>;
};

const GfeContext = createContext<GfeContextType | undefined>(undefined);

export default GfeContext;
